
<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h4>REPORTE DE INGRESOS ALMACEN</h4>
        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarExistencia()"
          class="form-horizontal form-material noprint"
          id="categoryform"
          novalidate
        >
          <button onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>
          <div class="form-row">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['producto']"
                [controlName]="'Producto'"
              >
                <label for="inputGroupSelect02">Producto</label>
                <ng-select
                  bindLabel="name"
                  placeholder="Selecionar Producto"
                  [searchable]="true"
                  (change)="getSelectedProduct($event)"
                  formControlName="producto"
                >
                  <ng-option>
                    Seleccionar todos
                  </ng-option>
                  <ng-option [value]="item" *ngFor="let item of products">
                    {{ item.nombre_producto }}
                  </ng-option>
                </ng-select>
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['inicio']"
                [controlName]="'Fecha Inicio'"
              >
                <label for="inicio">Fecha Inicio</label>
                <input
                  class="form-control"
                  type="date"
                  id="inicio"
                  formControlName="inicio"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['fin']"
                [controlName]="'Fecha final'"
              >
                <label for="fin">Fecha fin</label>
                <input
                  class="form-control"
                  type="date"
                  id="fin"
                  formControlName="fin"
                />
              </app-form-error-wrapper>
              <!--              <input type="date" class="form-control" [ngModel]="final">-->
            </div>
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['comprobante']"
                [controlName]="'Comprobante'"
              >
                <label for="comprobante">Comprobante</label>
                <input
                  class="form-control"
                  type="text"
                  id="comprobante"
                  formControlName="comprobante"
                />
              </app-form-error-wrapper>
              <!--              <input type="date" class="form-control" [ngModel]="final">-->
            </div>

            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
            <!--              <button type="submit" class="btn btn-primary" (click)="ListarExistencia()">Buscar</button>-->
          </div>
        </form>
      </div>
      <div class="card-body">
        <table
          class="table table-bordered table-condensed table-hover table-responsive-md"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Fecha. Ingreso</th>
              <th>N. Cbte</th>
              <th>Nombre</th>
              <th>U.M</th>

              <th>codigo</th>

              <th>Cantidad</th>
              <th>Costo</th>
              <th>Sub. Total</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th scope="row">{{ i + 1 }}</th>
              <td>
                {{ data.fecha_ingreso }}
              </td>
              <td>{{ data.nro_comprobante }}</td>
              <td
                *ngIf="
                  checkStatus(data.existencia, data.limite_a);
                  else statusAmarillo
                "
                class="table-success"
              >
                {{ data.nombre }}
              </td>
              <ng-template #statusAmarillo>
                <td
                  *ngIf="
                    checkStatus(data.existencia, data.limite_r);
                    else statusRojo
                  "
                  class="table-warning"
                >
                  {{ data.nombre }}
                </td>
              </ng-template>
              <ng-template #statusRojo>
                <td class="table-danger">{{ data.nombre }}</td>
              </ng-template>
              <td>{{ data.unidad }}</td>

              <td>
                {{ data.codigo }}
              </td>

              <td>{{ data.cantidad }}</td>
              <td class="text-right"  >{{ data.costo }}</td>
              <td class="text-right">
                
                <b> {{ data.costo * data.cantidad | currency: 'BOB':'symbol-narrow':'1.2-2' }}</b>
              
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="6"></td>
              <td colspan="2 text-right">SUBTOTAL</td>
             
              <td class="text-right">
                <b>
                  {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}</b
                >
              </td>
            </tr>
          </tfoot>


        </table>
      </div>
    </div>
  </div>
</div>
